module.exports = __webpack_public_path__ + "static/media/md-stopwatch.d7f04ea5.svg";